// External dependencies
import { Button, ColorIndicator, ColorPicker, Popover } from "@wordpress/components";

export default (userOptions) => {
    const getAttr = (attribute) => {
        const store = userOptions.props.attributes;
        return !!store[attribute] ? store[attribute] : "";
    };

    let verifiedValue;
    const currentValue = getAttr(userOptions.attribute);
    if (!!currentValue.hex) {
        verifiedValue = currentValue.hex;
    } else {
        verifiedValue = userOptions.defaultValue || "";
    }

    const toggleOpen = () =>
        userOptions.props.updateAttributes({
            customToggles: { [userOptions.attribute]: true },
        });
    const toggleClose = () =>
        userOptions.props.updateAttributes({
            customToggles: { [userOptions.attribute]: false },
        });

    return (
        <>
            <Button
                variant="tertiary"
                label={userOptions.labelText}
                onClick={toggleOpen}
                style={{ flexDirection: "column-reverse", height: "60px", gap: "8px", alignItems: "flex-start" }}
            >
                <ColorIndicator colorValue={getAttr(userOptions.attribute).hex} />
                <span style={{ color: "#1B2559" }}>{userOptions.labelText}</span>
            </Button>
            {userOptions.props.attributes.customToggles[userOptions.attribute] && (
                <Popover animate={true} flip={true} expandOnMobile={true} onClose={toggleClose}>
                    <ColorPicker
                        color={verifiedValue}
                        enableAlpha={true}
                        onChangeComplete={(value) =>
                            userOptions.props.updateAttributes({ [userOptions.attribute]: value })
                        }
                    />
                    <Button
                        variant="tertiary"
                        onClick={() => userOptions.props.updateAttributes({ [userOptions.attribute]: "" })}
                        style={{ padding: "5px 10px", marginLeft: "18px", marginBottom: "18px" }}
                    >
                        {userOptions.resetText}
                    </Button>
                </Popover>
            )}
        </>
    );
};
